export default "__VITE_ASSET__Q1jrHw8J__"